<!--
 * @Author: cheesekun
 * @Date: 2021-03-24 15:14:33
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-09-01 20:36:39
 * @FilePath: \dc-vizier-tpl-h5\src\App.vue
-->
<template>
  <div id="app">
    <!-- <Home /> -->
    <router-view />
  </div>
</template>

<script>
// import Home from '@/views/Home'

export default {
  name: 'App'
  // components: {
  //   Home
  // }
}
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: relative;
}
</style>
